import {ActionContext, ActionTree} from 'vuex';
import {IdReference, RootState} from '@/store/type';
import {
  AnswerServiceTransaction,
  FilterServiceTransaction, ResponseServiceTransaction, ServiceTransaction,
  ServiceTransactionInitState,
  VerifyCodeEndInterface,
  VerifyCodeInterface
} from '@/store/service-transaction/service-transaction.types';
import {HttpService} from '@/services/api';
import {ResponseService} from '@/store/service/service.types';
import {ServiceTransactionEnumApi} from '@/store/service-transaction/service-transaction.enum';
import {MemberEnumApi} from '@/store/member/member.enum';
import {AxiosResponse} from 'axios';


export const ServiceTransactionAction: ActionTree<ServiceTransactionInitState, RootState> = {
  async _getServiceTransaction(req: ActionContext<ServiceTransactionInitState, RootState>, filter?: FilterServiceTransaction): Promise<void> {
    let {commit} = req;
    try {
      let res = await HttpService.get(ServiceTransactionEnumApi.ServiceTransaction, filter) as { data: ResponseService };
      commit('mutationGetServiceTransaction', res.data.data[0]);
    } catch (e) {
      commit('mutationGetServiceTransaction', {});
      console.error('DEBUG: _getServiceTransaction ', e.message);
    }
  },
  async _getServiceTransactionById(req: ActionContext<ServiceTransactionInitState, RootState>, id): Promise<void> {
    let {commit} = req;
    try {
      let res = await HttpService.get(ServiceTransactionEnumApi.ServiceTransaction + '/' + id) as { data: ResponseService };
      commit('mutationGetServiceTransaction', res.data.data[0]);
    } catch (e) {
      commit('mutationGetServiceTransaction', {});
      console.error('DEBUG: _getServiceTransaction ', e.message);
    }
  },
  async _getServiceTransactionByMemberId(req: ActionContext<ServiceTransactionInitState, RootState>, filter?: FilterServiceTransaction): Promise<void> {
    let {commit} = req;
    try {
      let res = await HttpService.get(ServiceTransactionEnumApi.ServiceTransaction + 'memberId', filter) as { data: ResponseService };
      console.log('DEBUG: res', res.data.data);
      commit('mutationGetServiceTransactions', res.data.data);
    } catch (e) {
      commit('mutationGetServiceTransactions', []);
      console.error('DEBUG: _getServiceTransaction ', e.message);
    }
  },
  async _generateCode(req: ActionContext<ServiceTransactionInitState, RootState>, filter?: FilterServiceTransaction): Promise<any> {
    let {commit} = req;
    try {
      let res = await HttpService.put(ServiceTransactionEnumApi.ServiceTransaction + 'generate-code', filter) as { data: ResponseService };
      console.log('DEBUG: res', res.data.data);
      commit('mutationGenerateCode', res.data.data);
      return res;
    } catch (e) {
      commit('mutationGenerateCode', []);
      console.error('DEBUG: _generateCode ', e.message);
    }
  },
  async _generateFinalCode(req: ActionContext<ServiceTransactionInitState, RootState>, star: number): Promise<any> {
    let {commit} = req;
    try {
      let res = await HttpService.put(ServiceTransactionEnumApi.ServiceTransaction + 'generate-final-code', {rating: star}) as { data: ResponseService };
      commit('mutationGenerateCode', res.data.data[0]);
      return res;
    } catch (e) {
      commit('mutationGenerateCode', {});
      console.error('DEBUG: _generateCode ', e.message);
    }
  },
  async _verifyCode(req: ActionContext<ServiceTransactionInitState, RootState>, body: VerifyCodeInterface): Promise<any> {
    let {commit, dispatch} = req;
    try {
      let res = await HttpService.post(ServiceTransactionEnumApi.ServiceTransaction + 'verify-code', body) as { data: ResponseService };
      await dispatch('handle/_httpResponse', res, {root: true});
      // commit('mutationVerifyCode', res.data.data);

      return res;
    } catch (e) {
      throw e;
    }
  },
  async _verifyCodeEnd(req: ActionContext<ServiceTransactionInitState, RootState>, body: VerifyCodeEndInterface): Promise<any> {
    let {commit, dispatch} = req;
    try {
      let res = await HttpService.post(ServiceTransactionEnumApi.ServiceTransaction + 'verify-code-end', body) as { data: ResponseService };
      await dispatch('handle/_httpResponse', res, {root: true});
      // commit('mutationVerifyCode', res.data.data);

      return res;
    } catch (e) {
      throw e;
    }
  },
  async _information(req: ActionContext<ServiceTransactionInitState, RootState>): Promise<any> {
    let {commit, dispatch} = req;
    try {
      let res = await HttpService.get(ServiceTransactionEnumApi.ServiceTransaction + 'information') as { data: ResponseService };
      await dispatch('handle/_httpResponse', res, {root: true});
      commit('mutationSetInformation', res.data.data[0]);
      return res;
    } catch (e) {
      throw e;
    }
  },
  async _getFinalInformation(req: ActionContext<ServiceTransactionInitState, RootState>, payload: IdReference): Promise<any> {
    let {commit, dispatch} = req;
    try {
      let res = await HttpService.get(ServiceTransactionEnumApi.ServiceTransaction + 'information/' + payload.id) as { data: ResponseService };
      await dispatch('handle/_httpResponse', res, {root: true});
      commit('mutationSetInformation', res.data.data[0]);
      return res;
    } catch (e) {
      throw e;
    }
  },
  _setRating: ({commit}, star: number) => commit('mutationSetRating', star),
  async _checkJobIsRunning(req: ActionContext<ServiceTransactionInitState, RootState>, payload: IdReference): Promise<any> {
    let {commit, dispatch} = req;
    try {
      let res = await HttpService.get(ServiceTransactionEnumApi.ServiceTransaction + 'job-running') as { data: ResponseService };
      commit('mutationSetJobRunning', res.data.data[0]);
      commit('mutationJobIsRunning',res.data.appCode === 20004);
      return res;
    } catch (e) {
      throw e;
    }
  },
  async _getServiceTransactionInviteList(req: ActionContext<ServiceTransactionInitState, RootState>): Promise<void> {
    let {commit} = req;
    try {
      let res = await HttpService.get(`${ServiceTransactionEnumApi.ServiceTransaction}invite`) as { data: ResponseService };
      if (res.data.appCode === 20000) {
        commit('mutationGetServiceTransactions', res.data.data);
      }else {
        commit('mutationGetServiceTransactions', []);
      }
    } catch (e) {
      commit('mutationGetServiceTransactions', []);
    }
  },
  async _answerServiceTransaction(req: ActionContext<ServiceTransactionInitState, RootState>, payload: AnswerServiceTransaction): Promise<void> {
    let {commit, dispatch} = req;
    try {
      let res = await HttpService.post(`${ServiceTransactionEnumApi.ServiceTransaction}invite/answer`, payload);
      await dispatch('_getServiceTransactionInviteList');
      return res
    } catch (e) {
      console.error('DEBUG: _answerServiceTransaction ', e.message);
    }
  },
  async _getServiceTransactionHistoryList(req: ActionContext<ServiceTransactionInitState, RootState>): Promise<void> {
    let {commit} = req;
    try {
      let res = await HttpService.get(`${ServiceTransactionEnumApi.ServiceTransaction}history`) as { data: ResponseService };
      commit('mutationGetServiceTransactionsHistory', res.data.data);
    } catch (e) {
      commit('mutationGetServiceTransactionsHistory', []);
      console.error('DEBUG: _getServiceTransactionHistoryList ', e.message);
    }
  },
  async _getAllServiceTransactionHistoryByMember(req: ActionContext<ServiceTransactionInitState, RootState>): Promise<void> {
    let {commit} = req;
    try {
      let res = await HttpService.get(`${ServiceTransactionEnumApi.ServiceTransaction}history/member`) as { data: ResponseService };
      commit('mutationGetServiceTransactionsHistory', res.data.data);
    } catch (e) {
      commit('mutationGetServiceTransactionsHistory', []);
      console.error('DEBUG: _getAllServiceTransactionHistoryByMember ', e.message);
    }
  },
  async _cancelActivity(req: ActionContext<ServiceTransactionInitState, RootState>, body: ServiceTransaction): Promise<AxiosResponse> {
    let {dispatch} = req;
    try {
      let res = await HttpService.put(`${ServiceTransactionEnumApi.ServiceTransaction}cancelActivity`, body) as { data: ResponseService };
      await dispatch('handle/_httpResponse', res, {root: true});
      return res as AxiosResponse;
    } catch (e) {
      throw e
    }
  },
  async _activityById(req: ActionContext<ServiceTransactionInitState, RootState>, payload: string): Promise<void> {
    let {commit, dispatch} = req;
    try {
      let res = await HttpService.get(`${ServiceTransactionEnumApi.ServiceTransaction}${payload}`) as { data: ResponseService };
      commit('mutationService', res.data.data[0]);
    } catch (e) {
      commit('mutationService', {});
    }
  },
  async _getServiceTransactionInviteReceiver(req: ActionContext<ServiceTransactionInitState, RootState>, params: string): Promise<void> {
    let {commit} = req;
    try {
      let serviceTransaction = await HttpService.get(`${ServiceTransactionEnumApi.ServiceTransaction}invite/receiver/${params}`) as { data: ResponseServiceTransaction };
      if (serviceTransaction.data.appCode === 20000) {
        commit('mutationGetServiceTransactionInviteReceiver', serviceTransaction.data.data);
      }else {
        commit('mutationGetServiceTransactionInviteReceiver', []);
      }
    } catch (e) {
      commit('mutationGetServiceTransactionInviteReceiver', []);
    }
  },
  async _getServiceTransactionInviteProvider(req: ActionContext<ServiceTransactionInitState, RootState>, params: string): Promise<void> {
    let {commit, dispatch} = req;
    try {
      let serviceTransaction = await HttpService.get(`${ServiceTransactionEnumApi.ServiceTransaction}invite/provider/${params}`) as { data: ResponseServiceTransaction };
      if (serviceTransaction.data.appCode === 20000) {
        commit('mutationGetServiceTransactionInviteProvider', serviceTransaction.data.data);
      } else {
        commit('mutationGetServiceTransactionInviteProvider', []);
      }
    } catch (e) {
      commit('mutationGetServiceTransactionInviteProvider', []);
    }
  },
  async _updateRead(req: ActionContext<ServiceTransactionInitState, RootState>, payload: string): Promise<AxiosResponse> {
    try {
      let res = await HttpService.put(`${ServiceTransactionEnumApi.ServiceTransaction}update/read/${payload}`,'') as { data: ResponseService };
      return res as AxiosResponse;
    } catch (e) {
      throw e
    }
  },
  async _getAllServiceActivityHistoryByMember(req: ActionContext<ServiceTransactionInitState, RootState>,params: {memberId:string, page:number, limit:number}): Promise<void> {
    let {commit} = req;
    try {
      let res = await HttpService.get(`${ServiceTransactionEnumApi.ServiceTransaction}history/activity/`, params) as { data: ResponseService };
      commit('mutationGetHistoryActivity', res.data.data);
    } catch (e) {
      commit('mutationGetHistoryActivity', []);
      console.error('DEBUG: _getAllServiceTransactionHistoryByMember ', e.message);
    }
  },


};
